import React from 'react';
import { Accordion, Form, Grid, Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { warehouseAvailabilityGroupByOptions, sortByOptions } from '../helper';
import { WarehouseReportEnum } from 'Common/FieldEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { WAREHOUSE_KITCHEN_AVAILABILITY_FORM_NAME } from 'Common/FormEnum';
import { SiteComponent } from 'Common/SiteComponent';
import { SiteTypeEnum } from 'Common/Constants/Enumeration/SiteTypeEnum';

const WarehouseAvailabilityComponent = props => {
  const { activeIndexes, handleCollapsePanelClick } = props;
  return (
    <Form>
      <Grid>
        <Grid.Row>
          <Grid.Column width={4} style={{ paddingLeft: 5 }}>
            <SiteComponent
              label={'Warehouse/Kitchen'}
              name={WarehouseReportEnum.WarehouseKitchen}
              onChange={this.dropDownChange}
              isForm={true}
              siteMasterTypeIds={[SiteTypeEnum.Warehouse, SiteTypeEnum.Kitchen]}
              style={{ marginBottom: '1rem' }}
              isAllRequired={true}
              checkIsLicensed={false}
              isAllValueZero={true}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Accordion fluid styled>
            <Accordion.Title
              active={activeIndexes.indexOf(0) !== -1}
              index={0}
              onClick={handleCollapsePanelClick}
            >
              <Icon name="dropdown" />
              <span className="text-orange">Sort By</span>
            </Accordion.Title>
            <Accordion.Content active={activeIndexes.indexOf(0) !== -1}>
              <Grid>
                <Grid.Row columns={3} className={'pt10'}>
                  <Grid.Column width={13} verticalAlign={'bottom'}>
                    <ReduxFormButtonGroup
                      options={sortByOptions}
                      formName={WAREHOUSE_KITCHEN_AVAILABILITY_FORM_NAME}
                      fieldName={WarehouseReportEnum.SortBy}
                      type={'button'}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndexes.indexOf(1) !== -1}
              index={1}
              onClick={handleCollapsePanelClick}
            >
              <Icon name="dropdown" />
              <span className="text-orange">Group By</span>
            </Accordion.Title>
            <Accordion.Content active={activeIndexes.indexOf(1) !== -1}>
              <Grid>
                <Grid.Row columns={3} className={'pt10'}>
                  <Grid.Column width={13} verticalAlign={'bottom'}>
                    <ReduxFormButtonGroup
                      options={warehouseAvailabilityGroupByOptions}
                      formName={WAREHOUSE_KITCHEN_AVAILABILITY_FORM_NAME}
                      fieldName={WarehouseReportEnum.GroupBy}
                      type={'button'}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Accordion.Content>
          </Accordion>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

WarehouseAvailabilityComponent.propTypes = {
  activeIndexes: PropTypes.array,
  handleCollapsePanelClick: PropTypes.func,
};

WarehouseAvailabilityComponent.defaultProps = {
  activeIndexes: [],
  handleCollapsePanelClick: () => {},
};

export default WarehouseAvailabilityComponent;



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousereport/components/WarehouseAvailability.js